<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M50.57 39.33a1.5 1.5 0 10-1.08 2.79C53.57 43.7 56 45.78 56 47.69c0 4-9.86 8.36-24 8.36S8 51.64 8 47.69c0-1.89 2.39-3.95 6.39-5.52a1.5 1.5 0 10-1.1-2.79C8 41.47 5 44.43 5 47.69c0 6.48 11.61 11.36 27 11.36s27-4.88 27-11.36c0-3.29-3-6.26-8.43-8.36z"/><path d="M30.59 42.71a2 2 0 002.82 0l10.65-10.65a1.5 1.5 0 10-2.12-2.12l-8.44 8.44V6.5a1.5 1.5 0 00-3 0v31.88l-8.44-8.44a1.5 1.5 0 10-2.12 2.12z"/></svg>